import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { asaasLoginGuardFn } from "@core/guards/asaas-login.guard";
import { AuthComponent } from "./auth.component";
import { AsaasLoginComponent } from "./pages/asaas-login/asaas-login.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { AsaasLoginErrorComponent } from "./pages/asaas-login-error/asaas-login-error.component";
import { LoginComponent } from "./pages/login/login.component";
import { AsaasComponent } from "./pages/asaas/asaas.component";

const routes: Routes = [
	{
		path: "",
		redirectTo: "/pages/auth/login",
		pathMatch: "full"
	},
	{
		path: "",
		component: AuthComponent,
		children: [
			{
				path: "login",
				component: LoginComponent,
				canActivate: [asaasLoginGuardFn]
			},
			{ path: "reset-password", component: ResetPasswordComponent }
		]
	},
	{
		path: "asaas-login",
		component: AsaasLoginComponent
	},
	{
		path: "asaas-login-error",
		component: AsaasLoginErrorComponent
	},
	{
		path: "asaas",
		component: AsaasComponent,
		canMatch: []
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AuthRoutingModule {}
